export default __webpack_public_path__ + "static/media/minus.0f058c6c.svg";